/**
 * Search Modal Component
 */
class SearchModal extends HTMLElement {
  constructor() {
    super();

    const _this = this;
    this.openSearchModal = document.querySelectorAll('.open-searchform');
    this.searchFormContainer = this.querySelector('.searchform');

    this.searchFormContainer.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') {
        this.close();
      }
    });

    this.openSearchModal.forEach((toggleBtn) => {
      toggleBtn.addEventListener('click', function (event) {
        _this.onToggleBtnClick(event);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
      toggleBtn.setAttribute('role', 'button');
      toggleBtn.setAttribute('aria-expanded', 'false');
    });
    this.querySelector('.search-modal__close-button').addEventListener('click', this.close.bind(this));
  }

  isOpen() {
    return this.searchFormContainer.hasAttribute('open');
  }

  onToggleBtnClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.searchFormContainer.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open(_event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.searchFormContainer.setAttribute('open', true);
    this.classList.add('open__modal');
    this.removeAttribute('style');
    document.body.addEventListener('click', this.onBodyClickEvent);

    Utility.trapFocus(this);
    const searchInput = this.querySelector('input[type="search"]');

    if (searchInput) {
      Utility.forceFocus(searchInput);

      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        setTimeout(() => {
          searchInput.click();
          searchInput.focus();
        }, 200);
      }
    }
  }

  close(_focusToggle = true) {
    Utility.removeTrapFocus();
    this.searchFormContainer.removeAttribute('open');
    this.classList.remove('open__modal');
    document.body.removeEventListener('click', this.onBodyClickEvent);

    const predictiveSearch = this.querySelector('predictive-search');
    if (predictiveSearch && typeof predictiveSearch.hideResults === 'function') {
      predictiveSearch.hideResults();
    }
  }
}

customElements.define('search-modal', SearchModal);
